function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.state-text{font-family:'Graphik';font-size:14px;fill: 'black';}\n\t.center{fill:white;}\n\t.st4{stroke:white;}\n\t.st5{stroke:white;}\n\t.st6{stroke:white;}\n\t.st7{stroke:white;}\n\t.st8{stroke:white;}\n\t.st9{stroke:white;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  id: "AL-center",
  className: "center",
  points: "471.4,354.6 487.2,345.5 502.9,354.5 502.9,372.6 487.2,381.7 471.4,372.6  "
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  id: "AL-center",
  transform: "matrix(1 0 0 1 477.25 369.1404)",
  className: "state-text"
}, "AL");

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "ALA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AL-jr",
  className: "st4",
  points: "502.5,363.6 502.5,372.6 486.8,381.7 471.1,372.6 471.1,363.6 455.4,363.6 455.4,381.7               486.8,399.8 518.2,381.7 518.2,363.6"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "ALB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AL-sr",
  className: "st5",
  points: "486.8,327.3 455.4,345.5 455.4,363.6 471.1,363.6 471.1,354.5 486.8,345.5 502.5,354.5               502.5,363.6 518.2,363.6 518.2,345.5"
}));

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  id: "AZ-center",
  className: "center",
  points: "125.6,300.3 141.3,291.2 157,300.3 157,318.4 141.3,327.5 125.6,318.4   "
});

var _ref8 = /*#__PURE__*/React.createElement("text", {
  id: "AZ-center",
  transform: "matrix(1 0 0 1 131.5 315.1703)",
  className: "state-text"
}, "AZ");

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "AZA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AZ-jr",
  className: "st5",
  points: "157,309.2 157,318.3 141.3,327.3 125.6,318.3 125.6,309.2 109.9,309.2 109.9,327.3               141.3,345.5 172.7,327.3 172.7,309.2"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "AZB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AZ-sr",
  className: "st5",
  points: "141.3,273 109.9,291.1 109.9,309.2 125.6,309.2 125.6,300.2 141.3,291.1 157,300.2 157,309.2 172.7,309.2 172.7,291.1"
}));

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  id: "AR-center",
  className: "center",
  points: "376.9,300.3 392.6,291.2 408.3,300.3 408.3,318.4 392.6,327.5 376.9,318.4"
});

var _ref12 = /*#__PURE__*/React.createElement("text", {
  id: "AR-center",
  transform: "matrix(1 0 0 1 382.9084 315.1701)",
  className: "state-text"
}, "AR");

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "ARA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AR-jr",
  className: "st6",
  points: "408.2,309.2 408.2,318.3 392.6,327.3 376.9,318.3 376.9,309.2 361.1,309.2 361.1,327.3 392.6,345.5 424,327.3 424,309.2  "
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "ARB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AR-sr",
  className: "st5",
  points: "392.5,273 361.1,291.1 361.1,309.2 376.8,309.2 376.8,300.2 392.5,291.1 408.3,300.2 408.3,309.2 424,309.2 424,291.1  "
}));

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  id: "CA-center",
  className: "center",
  points: "94.3,245.9 110,236.8 125.7,245.8 125.7,263.9 110,273 94.3,263.9   "
});

var _ref16 = /*#__PURE__*/React.createElement("text", {
  id: "CA-center",
  transform: "matrix(1 0 0 1 99.4 259.8401)",
  className: "state-text"
}, "CA");

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "CAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "CA-jr",
  className: "st5",
  points: "125.6,254.9 125.6,264 109.9,273 94.2,264 94.2,254.9 78.5,254.9 78.5,273 109.9,291.1 141.3,273 141.3,254.9"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "CAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "CA-sr",
  className: "st5",
  points: "109.9,218.7 78.5,236.8 78.5,254.9 94.2,254.9 94.2,245.9 109.9,236.8 125.6,245.9 125.6,254.9 141.3,254.9 141.3,236.8  "
}));

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  id: "CO-center",
  className: "center",
  points: "251.4,300.3 267.1,291.2 282.8,300.3 282.8,318.4 267.1,327.5 251.4,318.4"
});

var _ref20 = /*#__PURE__*/React.createElement("text", {
  id: "CO-center",
  transform: "matrix(1 0 0 1 257.1072 315.1702)",
  className: "state-text"
}, "CO");

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "COA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "CO-jr",
  className: "st7",
  points: "282.6,309.2 282.6,318.3 266.9,327.3 251.2,318.3 251.2,309.2 235.5,309.2 235.5,327.3 266.9,345.5 298.3,327.3 298.3,309.2"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "COB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "CO-sr",
  className: "st5",
  points: "266.9,273 235.5,291.1 235.5,309.2 251.2,309.2 251.2,300.2 266.9,291.1 282.6,300.2 282.6,309.2 298.3,309.2 298.3,291.1  "
}));

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  id: "CT-center",
  className: "center",
  points: "691.3,191.6 707,182.5 722.7,191.5 722.7,209.6 707,218.7 691.3,209.6   "
});

var _ref24 = /*#__PURE__*/React.createElement("text", {
  id: "CT-center",
  transform: "matrix(1 0 0 1 698.1121 205.97)",
  className: "state-text"
}, "CT");

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "CTA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "CT-jr",
  className: "st5",
  points: "722.3,200.6 722.3,209.6 706.6,218.7 690.9,209.6 690.9,200.6 675.2,200.6 675.2,218.7 706.6,236.8 738,218.7 738,200.6  "
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  id: "CTB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "CT-sr",
  className: "st5",
  points: "706.6,164.4 675.2,182.5 675.2,200.6 690.9,200.6 690.9,191.6 706.6,182.5 722.3,191.5 722.3,200.6 738,200.6 738,182.5  "
}));

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  id: "DE-center",
  className: "center",
  points: "659.6,246 675.3,236.9 691,245.9 691,264.1 675.3,273.1 659.6,264.1   "
});

var _ref28 = /*#__PURE__*/React.createElement("text", {
  id: "DE-center",
  transform: "matrix(1 0 0 1 665.5875 259.84)",
  className: "state-text"
}, "DE");

var _ref29 = /*#__PURE__*/React.createElement("g", {
  id: "DEA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "DE-jr",
  className: "st8",
  points: "690.9,254.9 690.9,264 675.2,273 659.5,264 659.5,254.9 643.8,254.9 643.8,273 675.2,291.1 706.6,273 706.6,254.9  "
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  id: "DEB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "DE-sr",
  className: "st5",
  points: "675.2,218.8 643.8,236.9 643.8,255 659.5,255 659.5,246 675.2,236.9 690.9,245.9 690.9,255 706.6,255 706.6,236.9  "
}));

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  id: "FL-center",
  className: "center",
  points: "565.3,408.9 581,399.8 596.7,408.8 596.7,426.9 581,436 565.3,426.9   "
});

var _ref32 = /*#__PURE__*/React.createElement("text", {
  id: "FL-center",
  transform: "matrix(1 0 0 1 572.825 422.6094)",
  className: "state-text"
}, "FL");

var _ref33 = /*#__PURE__*/React.createElement("g", {
  id: "FLA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "FL-jr",
  className: "st5",
  points: "596.7,417.9 596.7,426.9 581,436 565.3,426.9 565.3,417.9 549.6,417.9 549.6,436 581,454.1 612.4,436 612.4,417.9  "
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "FLB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "FL-sr",
  className: "st5",
  points: "581,381.7 549.6,399.8 549.6,417.9 565.3,417.9 565.3,408.9 581,399.8 596.7,408.8 596.7,417.9 612.4,417.9 612.4,399.8  "
}));

var _ref35 = /*#__PURE__*/React.createElement("polygon", {
  id: "GA-center",
  className: "center",
  points: "533.9,354.6 549.6,345.5 565.3,354.5 565.3,372.6 549.6,381.7 533.9,372.6 "
});

var _ref36 = /*#__PURE__*/React.createElement("text", {
  id: "GA-center",
  transform: "matrix(1 0 0 1 538.8 369.1404)",
  className: "state-text"
}, "GA");

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "GAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "GA-jr",
  className: "st4",
  points: "565.3,363.6 565.3,372.6 549.6,381.7 533.9,372.6 533.9,363.6 518.2,363.6 518.2,381.7 549.6,399.8 581,381.7 581,363.6  "
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  id: "GAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "GA-sr",
  className: "st5",
  points: "549.6,327.3 518.2,345.5 518.2,363.6 533.9,363.6 533.9,354.5 549.6,345.5 565.3,354.5 565.3,363.6 581,363.6 581,345.5  "
}));

var _ref39 = /*#__PURE__*/React.createElement("polygon", {
  id: "HI-center",
  className: "center",
  points: "84.7,408.8 100.4,399.7 116.1,408.7 116.1,426.8 100.4,435.9 84.7,426.8"
});

var _ref40 = /*#__PURE__*/React.createElement("text", {
  id: "HI-center",
  transform: "matrix(1 0 0 1 93.3851 422.609)",
  className: "state-text"
}, "HI");

var _ref41 = /*#__PURE__*/React.createElement("g", {
  id: "HIA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "HI-jr",
  className: "st5",
  points: "116.1,417.8 116.1,426.8 100.4,435.9 84.7,426.8 84.7,417.8 69,417.8 69,435.9 100.4,454 131.8,435.9 131.8,417.8  "
}));

var _ref42 = /*#__PURE__*/React.createElement("g", {
  id: "HIB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "HI-sr",
  className: "st5",
  points: "100.4,381.6 69,399.7 69,417.8 84.7,417.8 84.7,408.8 100.4,399.7 116.1,408.7 116.1,417.8 131.8,417.8 131.8,399.7  "
}));

var _ref43 = /*#__PURE__*/React.createElement("polygon", {
  id: "ID-center",
  className: "center",
  points: "157,137.2 172.7,128.1 188.4,137.2 188.4,155.3 172.7,164.4 157,155.3   "
});

var _ref44 = /*#__PURE__*/React.createElement("text", {
  id: "ID-center",
  transform: "matrix(1 0 0 1 165.9052 151.69)",
  className: "state-text"
}, "ID");

var _ref45 = /*#__PURE__*/React.createElement("g", {
  id: "IDA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "ID-jr",
  className: "st6",
  points: "188.4,146.2 188.4,155.3 172.7,164.4 157,155.3 157,146.2 141.3,146.2 141.3,164.4 172.7,182.5 204.1,164.4 204.1,146.2"
}));

var _ref46 = /*#__PURE__*/React.createElement("g", {
  id: "IDB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "ID-sr",
  className: "st5",
  points: "172.7,110 141.3,128.1 141.3,146.2 157,146.2 157,137.2 172.7,128.1 188.4,137.2 188.4,146.2 204.1,146.2 204.1,128.1"
}));

var _ref47 = /*#__PURE__*/React.createElement("polygon", {
  id: "IL-center",
  className: "center",
  points: "376.9,191.6 392.6,182.5 408.3,191.5 408.3,209.6 392.6,218.7 376.9,209.6   "
});

var _ref48 = /*#__PURE__*/React.createElement("text", {
  id: "IL-center",
  transform: "matrix(1 0 0 1 385.9316 205.97)",
  className: "state-text"
}, "IL");

var _ref49 = /*#__PURE__*/React.createElement("g", {
  id: "ILA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "IL-jr",
  className: "st5",
  points: "408.2,200.6 408.2,209.6 392.5,218.7 376.8,209.6 376.8,200.6 361.1,200.6 361.1,218.7 392.5,236.8 423.9,218.7 423.9,200.6"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", {
  id: "ILB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "IL-sr",
  className: "st8",
  points: "392.5,164.4 361.1,182.5 361.1,200.6 376.8,200.6 376.8,191.6 392.5,182.5 408.2,191.5 408.2,200.6 423.9,200.6 423.9,182.5"
}));

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  id: "IN-center",
  className: "center",
  points: "439.5,191.6 455.2,182.5 470.9,191.5 470.9,209.6 455.2,218.7 439.5,209.6"
});

var _ref52 = /*#__PURE__*/React.createElement("text", {
  id: "IN-center",
  transform: "matrix(1 0 0 1 448.5452 205.97)",
  className: "state-text"
}, "IN");

var _ref53 = /*#__PURE__*/React.createElement("g", {
  id: "INA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "IN-jr",
  className: "st5",
  points: "471,200.6 471,209.6 455.4,218.7 439.7,209.6 439.7,200.6 424,200.6 424,218.7 455.4,236.8 486.8,218.7 486.8,200.6"
}));

var _ref54 = /*#__PURE__*/React.createElement("g", {
  id: "INB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "IN-sr",
  className: "st5",
  points: "455.4,164.4 424,182.5 424,200.6 439.7,200.6 439.7,191.6 455.4,182.5 471.1,191.5 471.1,200.6 486.8,200.6 486.8,182.5"
}));

var _ref55 = /*#__PURE__*/React.createElement("polygon", {
  id: "IA-center",
  className: "center",
  points: "314,191.6 329.8,182.5 345.5,191.5 345.5,209.6 329.8,218.7 314,209.6   "
});

var _ref56 = /*#__PURE__*/React.createElement("text", {
  id: "IA-center",
  transform: "matrix(1 0 0 1 322.9301 205.9698)",
  className: "state-text"
}, "IA");

var _ref57 = /*#__PURE__*/React.createElement("g", {
  id: "IAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "IA-jr",
  className: "st4",
  points: "345.4,200.6 345.4,209.6 329.7,218.7 314,209.6 314,200.6 298.3,200.6 298.3,218.7 329.7,236.8 361.1,218.7 361.1,200.6  "
}));

var _ref58 = /*#__PURE__*/React.createElement("g", {
  id: "IAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "IA-sr",
  className: "st5",
  points: "329.7,164.4 298.3,182.5 298.3,200.6 314,200.6 314,191.6 329.7,182.5 345.5,191.5 345.5,200.6 361.1,200.6 361.1,182.5  "
}));

var _ref59 = /*#__PURE__*/React.createElement("polygon", {
  id: "KS-center",
  className: "center",
  points: "314,300.3 329.8,291.2 345.5,300.3 345.5,318.4 329.8,327.5 314,318.4   "
});

var _ref60 = /*#__PURE__*/React.createElement("text", {
  id: "KS-center",
  transform: "matrix(1 0 0 1 320.4724 315.1701)",
  className: "state-text"
}, "KS");

var _ref61 = /*#__PURE__*/React.createElement("g", {
  id: "KSA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "KS-jr",
  className: "st5",
  points: "345.4,309.2 345.4,318.3 329.7,327.3 314,318.3 314,309.2 298.3,309.2 298.3,327.3 329.7,345.5 361.1,327.3 361.1,309.2  "
}));

var _ref62 = /*#__PURE__*/React.createElement("g", {
  id: "KSB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "KS-sr",
  className: "st6",
  points: "329.7,273 298.3,291.1 298.3,309.2 314,309.2 314,300.2 329.7,291.1 345.4,300.2 345.4,309.2 361.1,309.2 361.1,291.1  "
}));

var _ref63 = /*#__PURE__*/React.createElement("polygon", {
  id: "KY-center",
  className: "center",
  points: "408.2,245.9 424,236.8 439.7,245.8 439.7,263.9 424,273 408.2,263.9   "
});

var _ref64 = /*#__PURE__*/React.createElement("text", {
  id: "KY-center",
  transform: "matrix(1 0 0 1 414.6776 259.84)",
  className: "state-text"
}, "KY");

var _ref65 = /*#__PURE__*/React.createElement("g", {
  id: "KYA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "KY-jr",
  className: "st5",
  points: "439.6,254.9 439.6,264 423.9,273 408.2,264 408.2,254.9 392.5,254.9 392.5,273 423.9,291.1 455.4,273 455.4,254.9"
}));

var _ref66 = /*#__PURE__*/React.createElement("g", {
  id: "KYB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "KY-sr",
  className: "st6",
  points: "423.9,218.7 392.5,236.8 392.5,254.9 408.2,254.9 408.2,245.9 423.9,236.8 439.6,245.8 439.6,254.9 455.3,254.9 455.3,236.8"
}));

var _ref67 = /*#__PURE__*/React.createElement("polygon", {
  id: "LA-center",
  className: "center",
  points: "345.9,354.6 361.6,345.5 377.3,354.5 377.3,372.6 361.6,381.7 345.9,372.6"
});

var _ref68 = /*#__PURE__*/React.createElement("text", {
  id: "LA-center",
  transform: "matrix(1 0 0 1 352.247 369.1404)",
  className: "state-text"
}, "LA");

var _ref69 = /*#__PURE__*/React.createElement("g", {
  id: "LAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "LA-jr",
  className: "st5",
  points: "376.9,363.6 376.9,372.6 361.1,381.7 345.4,372.6 345.4,363.6 329.7,363.6 329.7,381.7               361.1,399.8 392.5,381.7 392.5,363.6"
}));

var _ref70 = /*#__PURE__*/React.createElement("g", {
  id: "LAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "LA-sr",
  className: "st4",
  points: "361.1,327.3 329.7,345.5 329.7,363.6 345.4,363.6 345.4,354.5 361.1,345.5 376.9,354.5 376.9,363.6 392.5,363.6 392.5,345.5"
}));

var _ref71 = /*#__PURE__*/React.createElement("polygon", {
  id: "ME-center",
  className: "center",
  points: "722.3,28.5 738,19.4 753.7,28.4 753.7,46.5 738,55.6 722.3,46.5   "
});

var _ref72 = /*#__PURE__*/React.createElement("text", {
  id: "ME-center",
  transform: "matrix(1 0 0 1 728.21 43.37)",
  className: "state-text"
}, "ME");

var _ref73 = /*#__PURE__*/React.createElement("g", {
  id: "MEA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "ME-jr",
  className: "st5",
  points: "753.7,37.6 753.7,46.6 738,55.7 722.3,46.6 722.3,37.6 706.6,37.6 706.6,55.7 738,73.8 769.4,55.7 769.4,37.6"
}));

var _ref74 = /*#__PURE__*/React.createElement("g", {
  id: "MEB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "ME-sr",
  className: "st7",
  points: "738,1.4 706.6,19.5 706.6,37.6 722.3,37.6 722.3,28.6 738,19.5 753.7,28.5 753.7,37.6 769.4,37.6 769.4,19.5"
}));

var _ref75 = /*#__PURE__*/React.createElement("polygon", {
  id: "MD-center",
  className: "center",
  points: "596.7,245.9 612.4,236.8 628.1,245.8 628.1,263.9 612.4,273 596.7,263.9"
});

var _ref76 = /*#__PURE__*/React.createElement("text", {
  id: "MD-center",
  transform: "matrix(1 0 0 1 602.0043 259.8408)",
  className: "state-text"
}, "MD");

var _ref77 = /*#__PURE__*/React.createElement("g", {
  id: "MDA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MD-jr",
  className: "st5",
  points: "628.1,254.9 628.1,264 612.4,273 596.7,264 596.7,254.9 581,254.9 581,273 612.4,291.1               643.8,273 643.8,254.9"
}));

var _ref78 = /*#__PURE__*/React.createElement("g", {
  id: "MDB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MD-sr",
  className: "st5",
  points: "612.4,218.7 581,236.8 581,254.9 596.7,254.9 596.7,245.9 612.4,236.8 628.1,245.8 628.1,254.9 643.8,254.9 643.8,236.8"
}));

var _ref79 = /*#__PURE__*/React.createElement("polygon", {
  id: "MA-center",
  className: "center",
  points: "659.6,137.2 675.3,128.1 691,137.2 691,155.3 675.3,164.4 659.6,155.3   "
});

var _ref80 = /*#__PURE__*/React.createElement("text", {
  id: "MA-center",
  transform: "matrix(1 0 0 1 663.8 151.6901)",
  className: "state-text"
}, "MA");

var _ref81 = /*#__PURE__*/React.createElement("g", {
  id: "MAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MA-jr",
  className: "st5",
  points: "690.9,146.2 690.9,155.3 675.2,164.4 659.5,155.3 659.5,146.2 643.8,146.2 643.8,164.4 675.2,182.5 706.6,164.4 706.6,146.2"
}));

var _ref82 = /*#__PURE__*/React.createElement("g", {
  id: "MAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MA-sr",
  className: "st8",
  points: "675.2,110 643.8,128.1 643.8,146.2 659.5,146.2 659.5,137.2 675.2,128.1 690.9,137.2 690.9,146.2 706.6,146.2 706.6,128.1"
}));

var _ref83 = /*#__PURE__*/React.createElement("polygon", {
  id: "MI-center",
  className: "center",
  points: "471,137.2 486.7,128.1 502.4,137.2 502.4,155.3 486.7,164.4 471,155.3   "
});

var _ref84 = /*#__PURE__*/React.createElement("text", {
  id: "MI-center",
  transform: "matrix(1 0 0 1 479.735 151.69)",
  className: "state-text"
}, "MI");

var _ref85 = /*#__PURE__*/React.createElement("g", {
  id: "MIA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MI-jr",
  className: "st9",
  points: "502.5,146.2 502.5,155.3 486.8,164.4 471.1,155.3 471.1,146.2 455.4,146.2 455.4,164.4 486.8,182.5 518.2,164.4 518.2,146.2"
}));

var _ref86 = /*#__PURE__*/React.createElement("g", {
  id: "MIB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MI-sr",
  className: "st5",
  points: "486.8,110 455.4,128.1 455.4,146.2 471.1,146.2 471.1,137.2 486.8,128.1 502.5,137.2 502.5,146.2 518.2,146.2 518.2,128.1"
}));

var _ref87 = /*#__PURE__*/React.createElement("polygon", {
  id: "MN-center",
  className: "center",
  points: "345.9,137.2 361.6,128.1 377.3,137.2 377.3,155.3 361.6,164.4 345.9,155.3   "
});

var _ref88 = /*#__PURE__*/React.createElement("text", {
  id: "MN-center",
  transform: "matrix(1 0 0 1 349.85 151.69)",
  className: "state-text"
}, "MN");

var _ref89 = /*#__PURE__*/React.createElement("g", {
  id: "MNA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MN-jr",
  className: "st8",
  points: "376.9,146.2 376.9,155.3 361.2,164.4 345.4,155.3 345.4,146.2 329.7,146.2 329.7,164.4               361.2,182.5 392.6,164.4 392.6,146.2   "
}));

var _ref90 = /*#__PURE__*/React.createElement("g", {
  id: "MNB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MN-sr",
  className: "st5",
  points: "361.2,110 329.7,128.1 329.7,146.2 345.4,146.2 345.4,137.2 361.2,128.1 376.9,137.2               376.9,146.2 392.6,146.2 392.6,128.1   "
}));

var _ref91 = /*#__PURE__*/React.createElement("polygon", {
  id: "MS-center",
  className: "center",
  points: "408.2,354.6 424,345.5 439.7,354.5 439.7,372.6 424,381.7 408.2,372.6   "
});

var _ref92 = /*#__PURE__*/React.createElement("text", {
  id: "MS-center",
  transform: "matrix(1 0 0 1 413.9369 369.1407)",
  className: "state-text"
}, "MS");

var _ref93 = /*#__PURE__*/React.createElement("g", {
  id: "MSA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MS-jr",
  className: "st6",
  points: "439.7,363.6 439.7,372.6 424,381.7 408.3,372.6 408.3,363.6 392.5,363.6 392.5,381.7               424,399.8 455.4,381.7 455.4,363.6   "
}));

var _ref94 = /*#__PURE__*/React.createElement("g", {
  id: "MSB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MS-sr",
  className: "st5",
  points: "424,327.3 392.5,345.5 392.5,363.6 408.3,363.6 408.3,354.5 424,345.5 439.7,354.5               439.7,363.6 455.4,363.6 455.4,345.5   "
}));

var _ref95 = /*#__PURE__*/React.createElement("polygon", {
  id: "MO-center",
  className: "center",
  points: "345.9,245.9 361.6,236.8 377.3,245.8 377.3,263.9 361.6,273 345.9,263.9   "
});

var _ref96 = /*#__PURE__*/React.createElement("text", {
  id: "MO-center",
  transform: "matrix(1 0 0 1 350.1075 259.84)",
  className: "state-text"
}, "MO");

var _ref97 = /*#__PURE__*/React.createElement("g", {
  id: "MOA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MO-jr",
  className: "st5",
  points: "376.8,254.9 376.8,264 361.1,273 345.5,264 345.5,254.9 329.7,254.9 329.7,273 361.1,291.1               392.5,273 392.5,254.9   "
}));

var _ref98 = /*#__PURE__*/React.createElement("g", {
  id: "MOB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MO-sr",
  className: "st5",
  points: "361.1,218.7 329.7,236.8 329.7,254.9 345.4,254.9 345.4,245.9 361.1,236.8 376.9,245.8               376.9,254.9 392.5,254.9 392.5,236.8   "
}));

var _ref99 = /*#__PURE__*/React.createElement("polygon", {
  id: "MT-center",
  className: "center",
  points: "219.8,137.2 235.5,128.1 251.2,137.2 251.2,155.3 235.5,164.4 219.8,155.3   "
});

var _ref100 = /*#__PURE__*/React.createElement("text", {
  id: "MT-center",
  transform: "matrix(1 0 0 1 225.8323 151.69)",
  className: "state-text"
}, "MT");

var _ref101 = /*#__PURE__*/React.createElement("g", {
  id: "MTA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MT-jr",
  className: "st6",
  points: "251.2,146.2 251.2,155.3 235.5,164.4 219.8,155.3 219.8,146.2 204.1,146.2 204.1,164.4               235.5,182.5 266.9,164.4 266.9,146.2   "
}));

var _ref102 = /*#__PURE__*/React.createElement("g", {
  id: "MTB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "MT-sr",
  className: "st5",
  points: "235.5,110 204.1,128.1 204.1,146.2 219.8,146.2 219.8,137.2 235.5,128.1 251.2,137.2               251.2,146.2 266.9,146.2 266.9,128.1   "
}));

var _ref103 = /*#__PURE__*/React.createElement("polygon", {
  id: "NE-center",
  className: "center",
  points: "282.6,245.9 298.3,236.8 314,245.8 314,263.9 298.3,273 282.6,263.9   "
});

var _ref104 = /*#__PURE__*/React.createElement("text", {
  id: "NE-center",
  transform: "matrix(1 0 0 1 289.0678 259.8403)",
  className: "state-text"
}, "NE");

var _ref105 = /*#__PURE__*/React.createElement("g", {
  id: "NEA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NE-jr",
  className: "st6",
  points: "314,254.9 314,264 298.3,273 282.6,264 282.6,254.9 266.9,254.9 266.9,273 298.3,291.1               329.7,273 329.7,254.9   "
}));

var _ref106 = /*#__PURE__*/React.createElement("g", {
  id: "NEB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NE-sr",
  className: "st5",
  points: "298.3,218.7 266.9,236.8 266.9,254.9 282.6,254.9 282.6,245.9 298.3,236.8 314,245.8               314,254.9 329.7,254.9 329.7,236.8   "
}));

var _ref107 = /*#__PURE__*/React.createElement("polygon", {
  id: "NV-center",
  className: "center",
  points: "156.9,245.9 172.6,236.8 188.3,245.8 188.3,263.9 172.6,273 156.9,263.9   "
});

var _ref108 = /*#__PURE__*/React.createElement("text", {
  id: "NV-center",
  transform: "matrix(1 0 0 1 162.2 259.8401)",
  className: "state-text"
}, "NV");

var _ref109 = /*#__PURE__*/React.createElement("g", {
  id: "NVA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NV-jr",
  className: "st5",
  points: "188.4,254.9 188.4,264 172.7,273 157,264 157,254.9 141.3,254.9 141.3,273 172.7,291.1               204.1,273 204.1,254.9   "
}));

var _ref110 = /*#__PURE__*/React.createElement("g", {
  id: "NVB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NV-sr",
  className: "st5",
  points: "172.7,218.7 141.3,236.8 141.3,254.9 157,254.9 157,245.9 172.7,236.8 188.4,245.9               188.4,254.9 204.1,254.9 204.1,236.8   "
}));

var _ref111 = /*#__PURE__*/React.createElement("polygon", {
  id: "NH-center",
  className: "center",
  points: "690.9,82.9 706.6,73.8 722.3,82.9 722.3,101 706.6,110 690.9,101  "
});

var _ref112 = /*#__PURE__*/React.createElement("text", {
  id: "NH-center",
  transform: "matrix(1 0 0 1 695.9 97.2603)",
  className: "state-text"
}, "NH");

var _ref113 = /*#__PURE__*/React.createElement("g", {
  id: "NHA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NH-jr",
  className: "st5",
  points: "722.3,91.9 722.3,101 706.6,110 690.9,101 690.9,91.9 675.2,91.9 675.2,110 706.6,128.1               738,110 738,91.9  "
}));

var _ref114 = /*#__PURE__*/React.createElement("g", {
  id: "NHB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NH-sr",
  className: "st8",
  points: "706.6,55.7 675.2,73.8 675.2,91.9 690.9,91.9 690.9,82.9 706.6,73.8 722.3,82.9 722.3,91.9               738,91.9 738,73.8   "
}));

var _ref115 = /*#__PURE__*/React.createElement("polygon", {
  id: "NJ-center",
  className: "center",
  points: "628.1,191.6 643.8,182.5 659.5,191.5 659.5,209.6 643.8,218.7 628.1,209.6   "
});

var _ref116 = /*#__PURE__*/React.createElement("text", {
  id: "NJ-center",
  transform: "matrix(1 0 0 1 635.3973 205.97)",
  className: "state-text"
}, "NJ");

var _ref117 = /*#__PURE__*/React.createElement("g", {
  id: "NJA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NJ-jr",
  className: "st8",
  points: "659.6,200.6 659.6,209.6 643.9,218.7 628.2,209.6 628.2,200.6 612.5,200.6 612.5,218.7               643.9,236.8 675.3,218.7 675.3,200.6   "
}));

var _ref118 = /*#__PURE__*/React.createElement("g", {
  id: "NJB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NJ-sr",
  className: "st5",
  points: "643.8,164.4 612.4,182.5 612.4,200.6 628.1,200.6 628.1,191.6 643.8,182.5 659.5,191.5               659.5,200.6 675.2,200.6 675.2,182.5   "
}));

var _ref119 = /*#__PURE__*/React.createElement("polygon", {
  id: "NM-center",
  className: "center",
  points: "188.4,300.3 204.1,291.2 219.8,300.3 219.8,318.4 204.1,327.5 188.4,318.4   "
});

var _ref120 = /*#__PURE__*/React.createElement("text", {
  id: "NM-center",
  transform: "matrix(1 0 0 1 192.5 315.1701)",
  className: "state-text"
}, "NM");

var _ref121 = /*#__PURE__*/React.createElement("g", {
  id: "NMA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NM-jr",
  className: "st5",
  points: "219.9,309.2 219.9,318.3 204.1,327.3 188.4,318.3 188.4,309.2 172.7,309.2 172.7,327.3               204.1,345.5 235.6,327.3 235.6,309.2   "
}));

var _ref122 = /*#__PURE__*/React.createElement("g", {
  id: "NMB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NM-sr",
  className: "st8",
  points: "204.1,273 172.7,291.1 172.7,309.2 188.4,309.2 188.4,300.2 204.1,291.1 219.9,300.2               219.9,309.2 235.6,309.2 235.6,291.1   "
}));

var _ref123 = /*#__PURE__*/React.createElement("polygon", {
  id: "NY-center",
  className: "center",
  points: "596.8,137.2 612.5,128.1 628.2,137.2 628.2,155.3 612.5,164.4 596.8,155.3   "
});

var _ref124 = /*#__PURE__*/React.createElement("text", {
  id: "NY-center",
  transform: "matrix(1 0 0 1 603.21 151.6901)",
  className: "state-text"
}, "NY");

var _ref125 = /*#__PURE__*/React.createElement("g", {
  id: "NYA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NY-jr",
  className: "st5",
  points: "628.1,146.2 628.1,155.3 612.4,164.4 596.7,155.3 596.7,146.2 581,146.2 581,164.4               612.4,182.5 643.8,164.4 643.8,146.2   "
}));

var _ref126 = /*#__PURE__*/React.createElement("g", {
  id: "NYB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NY-sr",
  className: "st5",
  points: "612.4,110 581,128.1 581,146.2 596.7,146.2 596.7,137.2 612.4,128.1 628.1,137.2               628.1,146.2 643.8,146.2 643.8,128.1   "
}));

var _ref127 = /*#__PURE__*/React.createElement("polygon", {
  id: "NC-center",
  className: "center",
  points: "502.7,300.3 518.4,291.2 534.1,300.3 534.1,318.4 518.4,327.5 502.7,318.4   "
});

var _ref128 = /*#__PURE__*/React.createElement("text", {
  id: "NC-center",
  transform: "matrix(1 0 0 1 508.4589 315.17)",
  className: "state-text"
}, "NC");

var _ref129 = /*#__PURE__*/React.createElement("g", {
  id: "NCA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NC-jr",
  className: "st4",
  points: "533.9,309.2 533.9,318.3 518.2,327.3 502.5,318.3 502.5,309.2 486.8,309.2 486.8,327.3               518.2,345.5 549.6,327.3 549.6,309.2   "
}));

var _ref130 = /*#__PURE__*/React.createElement("g", {
  id: "NCB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "NC-sr",
  className: "st5",
  points: "518.2,273 486.8,291.1 486.8,309.2 502.5,309.2 502.5,300.2 518.2,291.1 533.9,300.2               533.9,309.2 549.6,309.2 549.6,291.1   "
}));

var _ref131 = /*#__PURE__*/React.createElement("polygon", {
  id: "ND-center",
  className: "center",
  points: "282.6,137.2 298.3,128.1 314,137.2 314,155.3 298.3,164.4 282.6,155.3   "
});

var _ref132 = /*#__PURE__*/React.createElement("text", {
  id: "ND-center",
  transform: "matrix(1 0 0 1 288.6289 151.69)",
  className: "state-text"
}, "ND");

var _ref133 = /*#__PURE__*/React.createElement("g", {
  id: "NDA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "ND-jr",
  className: "st5",
  points: "314,146.2 314,155.3 298.3,164.4 282.6,155.3 282.6,146.2 266.9,146.2 266.9,164.4               298.3,182.5 329.7,164.4 329.7,146.2   "
}));

var _ref134 = /*#__PURE__*/React.createElement("g", {
  id: "NDB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "ND-sr",
  className: "st5",
  points: "298.3,110 266.9,128.1 266.9,146.2 282.6,146.2 282.6,137.2 298.3,128.1 314,137.2               314,146.2 329.7,146.2 329.7,128.1   "
}));

var _ref135 = /*#__PURE__*/React.createElement("polygon", {
  id: "OH-center",
  className: "center",
  points: "502.7,191.6 518.4,182.5 534.1,191.5 534.1,209.6 518.4,218.7 502.7,209.6   "
});

var _ref136 = /*#__PURE__*/React.createElement("text", {
  id: "OH-center",
  transform: "matrix(1 0 0 1 507 205.97)",
  className: "state-text"
}, "OH");

var _ref137 = /*#__PURE__*/React.createElement("g", {
  id: "OHA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "OH-jr",
  className: "st5",
  points: "533.9,200.6 533.9,209.6 518.2,218.7 502.5,209.6 502.5,200.6 486.8,200.6 486.8,218.7               518.2,236.8 549.6,218.7 549.6,200.6   "
}));

var _ref138 = /*#__PURE__*/React.createElement("g", {
  id: "OHB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "OH-sr",
  className: "st5",
  points: "518.2,164.4 486.8,182.5 486.8,200.6 502.5,200.6 502.5,191.6 518.2,182.5 533.9,191.5               533.9,200.6 549.6,200.6 549.6,182.5   "
}));

var _ref139 = /*#__PURE__*/React.createElement("polygon", {
  id: "OK-center",
  className: "center",
  points: "282.6,354.6 298.3,345.5 314,354.5 314,372.6 298.3,381.7 282.6,372.6   "
});

var _ref140 = /*#__PURE__*/React.createElement("text", {
  id: "OK-center",
  transform: "matrix(1 0 0 1 288.2575 369.1404)",
  className: "state-text"
}, "OK");

var _ref141 = /*#__PURE__*/React.createElement("g", {
  id: "OKA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "OK-jr",
  className: "st5",
  points: "314,363.6 314,372.6 298.3,381.7 282.6,372.6 282.6,363.6 266.9,363.6 266.9,381.7               298.3,399.8 329.7,381.7 329.7,363.6   "
}));

var _ref142 = /*#__PURE__*/React.createElement("g", {
  id: "OKB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "OK-sr",
  className: "st6",
  points: "298.3,327.3 266.9,345.5 266.9,363.6 282.6,363.6 282.6,354.5 298.3,345.5 314,354.5               314,363.6 329.7,363.6 329.7,345.5   "
}));

var _ref143 = /*#__PURE__*/React.createElement("polygon", {
  id: "OR-center",
  className: "center",
  points: "125.6,191.6 141.3,182.5 157,191.5 157,209.6 141.3,218.7 125.6,209.6   "
});

var _ref144 = /*#__PURE__*/React.createElement("text", {
  id: "OR-center",
  transform: "matrix(1 0 0 1 131.3024 205.9698)",
  className: "state-text"
}, "OR");

var _ref145 = /*#__PURE__*/React.createElement("g", {
  id: "ORA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "OR-jr",
  className: "st8",
  points: "157,200.6 157,209.6 141.3,218.7 125.6,209.6 125.6,200.6 109.9,200.6 109.9,218.7               141.3,236.8 172.7,218.7 172.7,200.6   "
}));

var _ref146 = /*#__PURE__*/React.createElement("g", {
  id: "ORB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "OR-sr",
  className: "st5",
  points: "141.3,164.4 109.9,182.5 109.9,200.6 125.6,200.6 125.6,191.6 141.3,182.5 157,191.5               157,200.6 172.7,200.6 172.7,182.5   "
}));

var _ref147 = /*#__PURE__*/React.createElement("polygon", {
  id: "PA-center",
  className: "center",
  points: "565.3,191.6 581,182.5 596.7,191.5 596.7,209.6 581,218.7 565.3,209.6   "
});

var _ref148 = /*#__PURE__*/React.createElement("text", {
  id: "PA-center",
  transform: "matrix(1 0 0 1 572.0848 205.97)",
  className: "state-text"
}, "PA");

var _ref149 = /*#__PURE__*/React.createElement("g", {
  id: "PAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "PA-jr",
  className: "st5",
  points: "596.7,200.6 596.7,209.6 581,218.7 565.3,209.6 565.3,200.6 549.6,200.6 549.6,218.7               581,236.8 612.4,218.7 612.4,200.6   "
}));

var _ref150 = /*#__PURE__*/React.createElement("g", {
  id: "PAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "PA-sr",
  className: "st5",
  points: "581,164.4 549.6,182.5 549.6,200.6 565.3,200.6 565.3,191.6 581,182.5 596.7,191.5               596.7,200.6 612.4,200.6 612.4,182.5   "
}));

var _ref151 = /*#__PURE__*/React.createElement("polygon", {
  id: "RI-center",
  className: "center",
  points: "722.3,137.2 738,128.1 753.7,137.2 753.7,155.3 738,164.4 722.3,155.3   "
});

var _ref152 = /*#__PURE__*/React.createElement("text", {
  id: "RI-center",
  transform: "matrix(1 0 0 1 731.3303 151.6901)",
  className: "state-text"
}, "RI");

var _ref153 = /*#__PURE__*/React.createElement("g", {
  id: "RIA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "RI-jr",
  className: "st5",
  points: "753.7,146.2 753.7,155.3 738,164.4 722.3,155.3 722.3,146.2 706.6,146.2 706.6,164.4               738,182.5 769.4,164.4 769.4,146.2   "
}));

var _ref154 = /*#__PURE__*/React.createElement("g", {
  id: "RIB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "RI-sr",
  className: "st8",
  points: "738,110 706.6,128.1 706.6,146.2 722.3,146.2 722.3,137.2 738,128.1 753.7,137.2               753.7,146.2 769.4,146.2 769.4,128.1   "
}));

var _ref155 = /*#__PURE__*/React.createElement("polygon", {
  id: "SC-center",
  className: "center",
  points: "565.3,300.3 581,291.2 596.7,300.3 596.7,318.4 581,327.5 565.3,318.4   "
});

var _ref156 = /*#__PURE__*/React.createElement("text", {
  id: "SC-center",
  transform: "matrix(1 0 0 1 570.9675 315.17)",
  className: "state-text"
}, "SC");

var _ref157 = /*#__PURE__*/React.createElement("g", {
  id: "SCA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "SC-jr",
  className: "st5",
  points: "596.7,309.2 596.7,318.3 581,327.3 565.3,318.3 565.3,309.2 549.6,309.2 549.6,327.3               581,345.5 612.4,327.3 612.4,309.2   "
}));

var _ref158 = /*#__PURE__*/React.createElement("g", {
  id: "SCB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "SC-sr",
  className: "st4",
  points: "581,273 549.6,291.1 549.6,309.2 565.3,309.2 565.3,300.2 581,291.1 596.7,300.2               596.7,309.2 612.4,309.2 612.4,291.1   "
}));

var _ref159 = /*#__PURE__*/React.createElement("polygon", {
  id: "SD-center",
  className: "center",
  points: "251.4,191.6 267.1,182.5 282.8,191.5 282.8,209.6 267.1,218.7 251.4,209.6   "
});

var _ref160 = /*#__PURE__*/React.createElement("text", {
  id: "SD-center",
  transform: "matrix(1 0 0 1 257.7374 205.9698)",
  className: "state-text"
}, "SD");

var _ref161 = /*#__PURE__*/React.createElement("g", {
  id: "SDA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "SD-jr",
  className: "st6",
  points: "282.6,200.6 282.6,209.6 266.9,218.7 251.2,209.6 251.2,200.6 235.5,200.6 235.5,218.7               266.9,236.8 298.3,218.7 298.3,200.6   "
}));

var _ref162 = /*#__PURE__*/React.createElement("g", {
  id: "SDB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "SD-sr",
  className: "st5",
  points: "266.9,164.4 235.5,182.5 235.5,200.6 251.2,200.6 251.2,191.6 266.9,182.5 282.6,191.5               282.6,200.6 298.3,200.6 298.3,182.5   "
}));

var _ref163 = /*#__PURE__*/React.createElement("polygon", {
  id: "TN-center",
  className: "center",
  points: "440.1,300.3 455.8,291.2 471.5,300.3 471.5,318.4 455.8,327.5 440.1,318.4   "
});

var _ref164 = /*#__PURE__*/React.createElement("text", {
  id: "TN-center",
  transform: "matrix(1 0 0 1 445.5 315.17)",
  className: "state-text"
}, "TN");

var _ref165 = /*#__PURE__*/React.createElement("g", {
  id: "TNA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "TN-jr",
  className: "st5",
  points: "471.1,309.2 471.1,318.3 455.4,327.3 439.7,318.3 439.7,309.2 424,309.2 424,327.3               455.4,345.5 486.8,327.3 486.8,309.2   "
}));

var _ref166 = /*#__PURE__*/React.createElement("g", {
  id: "TNB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "TN-sr",
  className: "st6",
  points: "455.4,273 424,291.1 424,309.2 439.7,309.2 439.7,300.2 455.4,291.1 471.1,300.2               471.1,309.2 486.8,309.2 486.8,291.1   "
}));

var _ref167 = /*#__PURE__*/React.createElement("polygon", {
  id: "TX-center",
  className: "center",
  points: "314,408.8 329.8,399.7 345.5,408.7 345.5,426.8 329.8,435.9 314,426.8   "
});

var _ref168 = /*#__PURE__*/React.createElement("text", {
  id: "TX-center",
  transform: "matrix(1 0 0 1 320.35 422.6096)",
  className: "state-text"
}, "TX");

var _ref169 = /*#__PURE__*/React.createElement("g", {
  id: "TXA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "TX-jr",
  className: "st5",
  points: "345.4,417.9 345.4,426.9 329.7,436 314,426.9 314,417.9 298.3,417.9 298.3,436 329.7,454.1               361.1,436 361.1,417.9   "
}));

var _ref170 = /*#__PURE__*/React.createElement("g", {
  id: "TXB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "TX-sr",
  className: "st6",
  points: "329.7,381.7 298.3,399.8 298.3,417.9 314,417.9 314,408.9 329.7,399.8 345.4,408.8               345.4,417.9 361.1,417.9 361.1,399.8   "
}));

var _ref171 = /*#__PURE__*/React.createElement("polygon", {
  id: "UT-center",
  className: "center",
  points: "219.8,245.9 235.6,236.8 251.3,245.8 251.3,263.9 235.6,273 219.8,263.9   "
});

var _ref172 = /*#__PURE__*/React.createElement("text", {
  id: "UT-center",
  transform: "matrix(1 0 0 1 226.6519 259.8405)",
  className: "state-text"
}, "UT");

var _ref173 = /*#__PURE__*/React.createElement("g", {
  id: "UTA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "UT-jr",
  className: "st5",
  points: "251.2,254.9 251.2,264 235.5,273 219.8,264 219.8,254.9 204.1,254.9 204.1,273 235.5,291.1               266.9,273 266.9,254.9   "
}));

var _ref174 = /*#__PURE__*/React.createElement("g", {
  id: "UTB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "UT-sr",
  className: "st5",
  points: "235.5,218.7 204.1,236.8 204.1,254.9 219.8,254.9 219.8,245.9 235.5,236.8 251.2,245.9               251.2,254.9 266.9,254.9 266.9,236.8   "
}));

var _ref175 = /*#__PURE__*/React.createElement("polygon", {
  id: "VT-center",
  className: "center",
  points: "628.1,82.9 643.8,73.8 659.5,82.9 659.5,101 643.8,110 628.1,101  "
});

var _ref176 = /*#__PURE__*/React.createElement("text", {
  id: "VT-center",
  transform: "matrix(1 0 0 1 634.3 97.26)",
  className: "state-text"
}, "VT");

var _ref177 = /*#__PURE__*/React.createElement("g", {
  id: "VTA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "VT-jr",
  className: "st5",
  points: "659.5,91.9 659.5,101 643.8,110 628.1,101 628.1,91.9 612.4,91.9 612.4,110 643.8,128.1               675.2,110 675.2,91.9  "
}));

var _ref178 = /*#__PURE__*/React.createElement("g", {
  id: "VTB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "VT-sr",
  className: "st5",
  points: "643.8,55.7 612.4,73.8 612.4,91.9 628.1,91.9 628.1,82.9 643.8,73.8 659.5,82.9 659.5,91.9               675.2,91.9 675.2,73.8   "
}));

var _ref179 = /*#__PURE__*/React.createElement("polygon", {
  id: "VA-center",
  className: "center",
  points: "533.9,245.9 549.6,236.8 565.3,245.8 565.3,263.9 549.6,273 533.9,263.9   "
});

var _ref180 = /*#__PURE__*/React.createElement("text", {
  id: "VA-center",
  transform: "matrix(1 0 0 1 539.5 259.8401)",
  className: "state-text"
}, "VA");

var _ref181 = /*#__PURE__*/React.createElement("g", {
  id: "VAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "VA-jr",
  className: "st5",
  points: "565.3,254.9 565.3,264 549.6,273 533.9,264 533.9,254.9 518.2,254.9 518.2,273 549.6,291.1               581,273 581,254.9   "
}));

var _ref182 = /*#__PURE__*/React.createElement("g", {
  id: "VAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "VA-sr",
  className: "st8",
  points: "549.6,218.8 518.2,236.9 518.2,255 533.9,255 533.9,246 549.6,236.9 565.3,245.9 565.3,255               581,255 581,236.9   "
}));

var _ref183 = /*#__PURE__*/React.createElement("polygon", {
  id: "WA-center",
  className: "center",
  points: "94.3,137.2 110,128.1 125.7,137.2 125.7,155.3 110,164.4 94.3,155.3   "
});

var _ref184 = /*#__PURE__*/React.createElement("text", {
  id: "WA-center",
  transform: "matrix(1 0 0 1 98.0398 151.69)",
  className: "state-text"
}, "WA");

var _ref185 = /*#__PURE__*/React.createElement("g", {
  id: "WAA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WA-jr",
  className: "st5",
  points: "125.6,146.2 125.6,155.3 109.9,164.4 94.2,155.3 94.2,146.2 78.5,146.2 78.5,164.4               109.9,182.5 141.3,164.4 141.3,146.2   "
}));

var _ref186 = /*#__PURE__*/React.createElement("g", {
  id: "WAB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WA-sr",
  className: "st5",
  points: "109.9,110 78.5,128.1 78.5,146.2 94.2,146.2 94.2,137.2 109.9,128.1 125.6,137.2               125.6,146.2 141.3,146.2 141.3,128.1   "
}));

var _ref187 = /*#__PURE__*/React.createElement("polygon", {
  id: "WV-center",
  className: "center",
  points: "471.1,245.9 486.8,236.8 502.5,245.8 502.5,263.9 486.8,273 471.1,263.9   "
});

var _ref188 = /*#__PURE__*/React.createElement("text", {
  id: "WV-center",
  transform: "matrix(1 0 0 1 474.1 259.8406)",
  className: "state-text"
}, "WV");

var _ref189 = /*#__PURE__*/React.createElement("g", {
  id: "WVA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WV-sr",
  className: "st5",
  points: "486.7,218.7 455.3,236.8 455.3,254.9 471,254.9 471,245.9 486.7,236.8 502.4,245.8               502.4,254.9 518.1,254.9 518.1,236.8   "
}));

var _ref190 = /*#__PURE__*/React.createElement("g", {
  id: "WVB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WV-jr",
  className: "st6",
  points: "502.4,254.9 502.4,264 486.7,273 471,264 471,254.9 455.3,254.9 455.3,273 486.7,291.1               518.1,273 518.1,254.9   "
}));

var _ref191 = /*#__PURE__*/React.createElement("polygon", {
  id: "WI-center",
  className: "center",
  points: "408.2,137.2 424,128.1 439.7,137.2 439.7,155.3 424,164.4 408.2,155.3   "
});

var _ref192 = /*#__PURE__*/React.createElement("text", {
  id: "WI-center",
  transform: "matrix(1 0 0 1 414 151.69)",
  className: "state-text"
}, "WI");

var _ref193 = /*#__PURE__*/React.createElement("g", {
  id: "WIA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WI-sr",
  className: "st5",
  points: "423.9,110 392.5,128.1 392.5,146.2 408.2,146.2 408.2,137.2 423.9,128.1 439.7,137.2               439.7,146.2 455.4,146.2 455.4,128.1   "
}));

var _ref194 = /*#__PURE__*/React.createElement("g", {
  id: "WIB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WI-jr",
  className: "st5",
  points: "439.7,146.2 439.7,155.3 423.9,164.4 408.2,155.3 408.2,146.2 392.5,146.2 392.5,164.4               423.9,182.5 455.4,164.4 455.4,146.2   "
}));

var _ref195 = /*#__PURE__*/React.createElement("polygon", {
  id: "WY-center",
  className: "center",
  points: "188.4,191.6 204.1,182.5 219.8,191.5 219.8,209.6 204.1,218.7 188.4,209.6   "
});

var _ref196 = /*#__PURE__*/React.createElement("text", {
  id: "WY-center",
  transform: "matrix(1 0 0 1 192 205.9698)",
  className: "state-text"
}, "WY");

var _ref197 = /*#__PURE__*/React.createElement("g", {
  id: "WYA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WY-sr",
  className: "st6",
  points: "204.1,164.4 172.7,182.5 172.7,200.6 188.4,200.6 188.4,191.6 204.1,182.5 219.8,191.5               219.8,200.6 235.5,200.6 235.5,182.5   "
}));

var _ref198 = /*#__PURE__*/React.createElement("g", {
  id: "WYB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "WY-jr",
  className: "st5",
  points: "219.8,200.6 219.8,209.6 204.1,218.7 188.4,209.6 188.4,200.6 172.7,200.6 172.7,218.7               204.1,236.8 235.5,218.7 235.5,200.6   "
}));

var _ref199 = /*#__PURE__*/React.createElement("polygon", {
  id: "AK-center",
  className: "center",
  points: "16.7,408.8 32.4,399.7 48.1,408.7 48.1,426.8 32.4,435.9 16.7,426.8   "
});

var _ref200 = /*#__PURE__*/React.createElement("text", {
  id: "AK-center",
  transform: "matrix(1 0 0 1 21.8 422.6097)",
  className: "state-text"
}, "AK");

var _ref201 = /*#__PURE__*/React.createElement("g", {
  id: "AKA"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AK-jr",
  className: "st6",
  points: "48.1,417.8 48.1,426.8 32.4,435.9 16.7,426.8 16.7,417.8 1,417.8 1,435.9 32.4,454               63.8,435.9 63.8,417.8"
}));

var _ref202 = /*#__PURE__*/React.createElement("g", {
  id: "AKB"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "AK-sr",
  className: "st5",
  points: "32.4,381.6 1,399.7 1,417.8 16.7,417.8 16.7,408.8 32.4,399.7 48.1,408.7 48.1,417.8 63.8,417.8 63.8,399.7"
}));

var SvgSenatehex2020 = function SvgSenatehex2020(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Senate_Map",
    viewBox: "0 0 771 456.16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSenatehex2020, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/senatehex2020.cc69520c.svg";
export { ForwardRef as ReactComponent };